
const TriangleTop = () => {
    return (
        <div
              className="text-blueGray-100 bottom-auto top-0 left-0 right-0 w-full pointer-events-none overflow-hidden pt-16 -mt-20"
              style={{ transform: "translateZ(0)" }}
              >
              <svg
                  className="bottom-0 overflow-hidden bg-blueGray-100"
                  xmlns="http://www.w3.org/2000/svg"
                  preserveAspectRatio="none"
                  version="1.1"
                  viewBox="0 0 2560 100"
                  x="0"
                  y="0"
              >
                  <polygon
                  className="text-white fill-current"
                  points="2560 0 2560 100 0 100"
                  ></polygon>
              </svg>
              </div>
    )
}

const TriangleBottom = () => {
    return (
        <div
              className="text-blueGray-100 bottom-auto top-0 left-0 right-0 w-full pointer-events-none overflow-hidden pt-20 -mt-20 h-30"
              style={{ transform: "translateZ(0)" }}
              >
              <svg
                  className="bottom-0 overflow-hidden bg-white"
                  xmlns="http://www.w3.org/2000/svg"
                  preserveAspectRatio="none"
                  version="1.1"
                  viewBox="0 0 2560 100"
                  x="0"
                  y="0"
              >
                  <polygon
                  className="text-blueGray-100 fill-current"
                  points="2560 0 2560 100 0 100"
                  ></polygon>
              </svg>
              </div>
    )
}


export {TriangleBottom, TriangleTop};